import React from 'react';

export default () => <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.5885 13.0916L18.001 7.18907V17.4566H3.00098V3.95657H4.50098V13.3616L8.62598 6.20657L13.501 9.04157L16.681 3.54407L17.9785 4.29407L14.056 11.0816L9.17348 8.26907L4.73348 15.9566H6.42848L9.72098 10.2866L14.5885 13.0916Z" fill="currentColor"/>
</svg>